module.exports = __webpack_public_path__ + "static/media/019.9e7b60e1.jpg";